import { resolveCountryCode } from './countries';

// Безопасный доступ к переменным окружения
const getEnvVar = (name, defaultValue = '') => {
  if (typeof process !== 'undefined' && process.env && process.env[name]) {
    return process.env[name];
  }
  // Fallback для браузера (если webpack не заменил переменные)
  if (typeof window !== 'undefined' && window.__ENV__ && window.__ENV__[name]) {
    return window.__ENV__[name];
  }
  return defaultValue;
};

// Используем относительные пути для продакшена, чтобы избежать CORS проблем
// Если REACT_APP_API_URL указывает на api.sportsground.ru, используем относительные пути
const REACT_APP_API_URL = getEnvVar('REACT_APP_API_URL', 'http://localhost:6060');
// Для админки всегда используем api.sportsground.ru для API запросов
const isProduction = REACT_APP_API_URL.includes('api.sportsground.ru') || REACT_APP_API_URL.includes('admin.sportsground.ru');
const URL = isProduction 
  ? 'https://api.sportsground.ru' // Для продакшена всегда используем api.sportsground.ru
  : REACT_APP_API_URL; // Для локальной разработки используем полный URL
const API_URL = isProduction
  ? 'https://api.sportsground.ru/api' // Для продакшена всегда используем api.sportsground.ru/api
  : `${REACT_APP_API_URL}/api`; // Для локальной разработки

// Экспортируем API_URL для использования в других компонентах
export { API_URL };

// авторизационный тоекн, добавляется в хедер Authorization
let token = null;

const setToken = (value) => {
  token = value;
};

const getDefaultHeaders = () => ({
  Authorization: `bearer ${token}`,
  BuildVersion: 'latest',
});

const getCenters = async () => {
  const response = await fetch(`${API_URL}/sportcomplexes`, {
    headers: getDefaultHeaders(),
  });
  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const getPlaygrounds = async () => {
  const response = await fetch(`${API_URL}/playgrounds`, {
    headers: getDefaultHeaders(),
  });
  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  const list = Array.isArray(result)
    ? result
    : (result && (result.items || result.$values || result.data)) || [];
  if (!Array.isArray(list)) return [];

  return list.map((playground) => {
    const { sports, ...rest } = playground || {};
    return {
      ...rest,
      workingHoursSports: sports,
    };
  });
};

const getPlayground = async (id) => {
  const response = await fetch(`${API_URL}/playgrounds/${id}`, {
    headers: getDefaultHeaders(),
  });
  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  if (result && result.sports) {
    return {
      ...result,
      workingHoursSports: result.sports,
    };
  }

  return result;
};

const getBookings = async () => {
  const response = await fetch(`${API_URL}/bookings`, {
    headers: getDefaultHeaders(),
  });
  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const getBooking = async (id) => {
  const response = await fetch(`${API_URL}/bookings/${id}`, {
    headers: getDefaultHeaders(),
  });
  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const createBooking = async (model) => {
  const response = await fetch(`${API_URL}/bookings`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const getTimetable = async (id, from, to, type) => {
  const response = await fetch(`${API_URL}/schedule/${id}/admin?from=${from}&to=${to}&type=${type}`, {
    headers: getDefaultHeaders(),
  });
  let result;

  if (response.ok) {
    result = await response.json();
    /**
     * т.к. сервер присылает $id (который ломает расписание площадки), то удалим его
     */
    delete result.$id;
  } else {
    // ИСПРАВЛЕНИЕ: Обрабатываем ошибки без вызова handleError, чтобы не происходил разлогин
    // Просто выбрасываем ошибку, которую обработает компонент
    if (response.status === 401) {
      const error = new Error('Unauthorized');
      error.status = response.status;
      throw error;
    }
    // Для других ошибок также выбрасываем ошибку
    const error = new Error(`Ошибка загрузки расписания: ${response.status} ${response.statusText}`);
    error.status = response.status;
    throw error;
  }
  return result;
};

const addTimetable = async (id, type) => {
  const response = await fetch(`${API_URL}/schedule/${id}/admin?type=${type}`, {
    method: 'POST',
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    // handleError(response);
    return {};
  }

  return result;
};

const getUsers = async (search = null) => {
  const url = search 
    ? `${API_URL}/webusers?search=${encodeURIComponent(search)}`
    : `${API_URL}/webusers`;
  const response = await fetch(url, {
    headers: getDefaultHeaders(),
  });
  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const createTimetable = async (timetable, id, type) => {
  const response = await fetch(`${API_URL}/schedule/${id}/admin?type=${type}`, {
    method: 'POST',
    body: JSON.stringify(timetable),
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  let result;

  if (response.ok) {
    result = await response.json();
    /**
     * т.к. сервер присылает $id (который ломает расписание площадки), то удалим его
     */
    delete result.$id;
  } else {
    await handleError(response);
  }

  return result;
};

const createCenter = async (model) => {
  // Создаем AbortController для таймаута
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 секунд таймаут
  
  try {
    const response = await fetch(`${API_URL}/sportcomplexes`, {
      method: 'POST',
      body: JSON.stringify(model),
      headers: {
        ...getDefaultHeaders(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      signal: controller.signal,
    });

    let result;

    if (response.ok) {
      result = await response.json();
    } else {
      await handleError(response);
    }

    clearTimeout(timeoutId);
    return result;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      const timeoutError = new Error('Превышено время ожидания ответа от сервера. Попробуйте еще раз.');
      timeoutError.status = 'Timeout';
      throw timeoutError;
    }
    throw error;
  }
};

const createPlayground = async (model) => {
  // Создаем AbortController для таймаута
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 секунд таймаут
  
  try {
    const response = await fetch(`${API_URL}/playgrounds`, {
      method: 'POST',
      body: JSON.stringify({
        ...model,
        price: model.price || null,
      }),
      headers: {
        ...getDefaultHeaders(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      signal: controller.signal,
    });

    let result;

    if (response.ok) {
      result = await response.json();
    } else {
      await handleError(response);
    }

    clearTimeout(timeoutId);
    return result;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      const timeoutError = new Error('Превышено время ожидания ответа от сервера. Попробуйте еще раз.');
      timeoutError.status = 'Timeout';
      throw timeoutError;
    }
    throw error;
  }
};

const createUser = async (model) => {
  const response = await fetch(`${API_URL}/webuser`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const setDeviceUser = async (model) => {
  const data = new FormData();
  data.append('deviceId', model);

  const response = await fetch(`${API_URL}/users/device`, {
    method: 'POST',
    headers: getDefaultHeaders(),
    body: data,
  });

  let result;

  if (response.ok) {
    result = true;
  } else {
    await handleError(response);
  }

  return result;
};

const updateCenter = async (model) => {
  // Создаем AbortController для таймаута
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 секунд таймаут
  
  try {
    const response = await fetch(`${API_URL}/sportcomplexes/${model.id}`, {
      method: 'PUT',
      body: JSON.stringify(model),
      headers: {
        ...getDefaultHeaders(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      signal: controller.signal,
    });

    let result;

    if (response.ok) {
      // Бэкенд возвращает 204 (NoContent) с пустым телом, поэтому используем model
      result = model;
    } else {
      await handleError(response);
    }

    clearTimeout(timeoutId);
    return result;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      const timeoutError = new Error('Превышено время ожидания ответа от сервера. Попробуйте еще раз.');
      timeoutError.status = 'Timeout';
      throw timeoutError;
    }
    throw error;
  }
};

// YClients интеграция по спортцентру
const getYClientsIntegration = async (complexId) => {
  const response = await fetch(`${API_URL}/sportcomplexes/${complexId}/yclients`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) {
    return await response.json();
  }
  await handleError(response);
};

const putYClientsIntegration = async (complexId, body) => {
  const response = await fetch(`${API_URL}/sportcomplexes/${complexId}/yclients`, {
    method: 'PUT',
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    await handleError(response);
  }
};

const getYClientsStaff = async (complexId) => {
  const response = await fetch(`${API_URL}/sportcomplexes/${complexId}/yclients/staff`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) {
    return await response.json();
  }
  await handleError(response);
};

const getYClientsServices = async (complexId) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 25000);
  try {
    const response = await fetch(`${API_URL}/sportcomplexes/${complexId}/yclients/services`, {
      headers: getDefaultHeaders(),
      signal: controller.signal,
    });
    clearTimeout(timeoutId);
    if (response.ok) {
      return await response.json();
    }
    await handleError(response);
  } catch (err) {
    clearTimeout(timeoutId);
    if (err.name === 'AbortError') {
      throw new Error('Превышено время ожидания ответа от сервера. Попробуйте ещё раз или проверьте доступность YClients.');
    }
    throw err;
  }
};

const putYClientsBindings = async (complexId, bindings) => {
  const response = await fetch(`${API_URL}/sportcomplexes/${complexId}/yclients/bindings`, {
    method: 'PUT',
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ bindings }),
  });
  if (!response.ok) {
    await handleError(response);
  }
};

const updatePlayground = async (model) => {
  // Создаем AbortController для таймаута
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 секунд таймаут
  
  try {
    const response = await fetch(`${API_URL}/playgrounds/${model.id}`, {
      method: 'PUT',
      body: JSON.stringify(model),
      headers: {
        ...getDefaultHeaders(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      signal: controller.signal,
    });
    let result;

    if (response.ok) {
      result = await response.json();
      // result = model; // это хак. Ручка возвращает только код
    } else {
      console.error('❌ Ошибка при обновлении площадки:', response.status, response.statusText);
      const errorText = await response.text();
      console.error('❌ Тело ошибки:', errorText);
      try {
        const errorJson = JSON.parse(errorText);
        console.error('❌ JSON ошибки:', errorJson);
      } catch (e) {
        console.error('❌ Не удалось распарсить ошибку как JSON');
      }
      await handleError(response);
    }

    clearTimeout(timeoutId);
    return result;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      const timeoutError = new Error('Превышено время ожидания ответа от сервера. Попробуйте еще раз.');
      timeoutError.status = 'Timeout';
      throw timeoutError;
    }
    throw error;
  }
};

const deletePlayground = async (id) => {
  const response = await fetch(`${API_URL}/playgrounds/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });

  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const uploadPhoto = async (file, playgroundId) => {
  const data = new FormData();
  data.append('data', file);
  data.append('isMain', false);
  data.append('playground', playgroundId);

  const response = await fetch(`${API_URL}/image`, {
    method: 'POST',
    body: data,
    headers: getDefaultHeaders(),
  });

  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const deletePhoto = async (id) => {
  const response = await fetch(`${API_URL}/image/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });

  let result;

  if (response.ok) {
    result = true;
  } else {
    await handleError(response);
  }

  return result;
};

const updatePhoto = async (id, model) => {
  const response = await fetch(`${API_URL}/image/${id}`, {
    method: 'PUT',
    body: JSON.stringify(model),
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  let result;

  if (response.ok) {
    result = true;
  } else {
    await handleError(response);
  }

  return result;
};

const updateUser = async (model) => {
  const response = await fetch(`${API_URL}/webuser/${model.id}`, {
    method: 'PUT',
    body: JSON.stringify(model),
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  let result;

  if (response.ok) {
    result = model; // await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const changePassword = async (id, newPassword) => {
  const response = await fetch(`${API_URL}/webuser/${id}/password`, {
    method: 'POST',
    body: JSON.stringify({ newPassword }),
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  let result;

  if (response.ok) {
    result = true;
  } else {
    await handleError(response);
  }

  return result;
};

const auth = async (login, password) => {
  // Проверяем, что параметры не пустые
  if (!login || !password) {
    throw new Error('Логин и пароль обязательны для авторизации');
  }

  const response = await fetch(`${URL}/auth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      BuildVersion: 'latest',
    },
    body: `grant_type=password&username=${encodeURIComponent(login)}&password=${encodeURIComponent(password)}`,
  });

  let result;

  if (response.ok) {
    try {
      // Сначала читаем как текст, чтобы можно было обработать ошибки парсинга
      const text = await response.text();
      
      // Проверяем Content-Type
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        try {
          result = JSON.parse(text);
        } catch (parseError) {
          // Если не удалось распарсить JSON, выбрасываем понятную ошибку
          throw new Error(`Ошибка парсинга JSON ответа сервера. Ответ: ${text.substring(0, 200)}`);
        }
      } else {
        // Если не JSON, выбрасываем ошибку с текстом ответа
        throw new Error(`Сервер вернул неожиданный формат ответа (ожидался JSON): ${text.substring(0, 100)}`);
      }
    } catch (error) {
      // Если это уже наша ошибка, просто пробрасываем её
      throw error;
    }
  } else {
    await handleError(response);
  }

  return result;
};

const getComments = async (id) => {
  const response = await fetch(`${API_URL}/comments/${id}`, {
    headers: getDefaultHeaders(),
  });

  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const getUser = async () => {
  const response = await fetch(`${API_URL}/webuser`, {
    method: 'GET',
    headers: getDefaultHeaders(),
  });
  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const deleteComment = async (id) => {
  const response = await fetch(`${API_URL}/comment/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });

  let result;

  if (response.ok) {
    result = true;
  } else {
    await handleError(response);
  }

  return result;
};

const updateBooking = async (id, model) => {
  const response = await fetch(`${API_URL}/bookings/${id}`, {
    method: 'PUT',
    body: JSON.stringify(model),
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  if (response.ok) {
    return true;
  }
  await handleError(response);
  return false;
};

const deleteBooking = async (id) => {
  const response = await fetch(`${API_URL}/bookings/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });

  let result;

  if (response.ok) {
    result = true;
  } else {
    await handleError(response);
  }

  return result;
};

const paidCancel = async (booking) => {
  const response = await fetch(`${API_URL}/paid/cancelpayment/${booking.id}`, {
    method: 'POST',
    headers: getDefaultHeaders(),
  });
  let result;

  if (response.ok) {
    result = true;
  } else {
    console.log(response);
    // handleError(response);
  }

  return result;
};

const deleteCenter = async (id) => {
  const response = await fetch(`${API_URL}/sportcomplexes/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });

  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const getTimezoneList = async () => {
  const response = await fetch(`${API_URL}/dictionary`, {
    method: 'GET',
    headers: getDefaultHeaders(),
  });
  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const registerModerator = async (model) => {
  const response = await fetch(`${API_URL}/moderator/register`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const resendConfirmation = async (email) => {
  const response = await fetch(`${API_URL}/moderator/resend-confirmation`, {
    method: 'POST',
    body: JSON.stringify({ email }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const confirmModeratorEmail = async (token, email) => {
  const response = await fetch(
    `${API_URL}/moderator/confirm-email?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`,
    {
      method: 'GET',
      redirect: 'manual',
    },
  );

  const status = response.status;
  let body = null;
  try {
    const text = await response.text();
    body = text ? JSON.parse(text) : null;
  } catch (err) {
    body = null;
  }

  return { status, body, type: response.type };
};

const getModeratorStatus = async () => {
  const response = await fetch(`${API_URL}/moderator/status`, {
    method: 'GET',
    headers: getDefaultHeaders(),
  });

  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const approveSportComplex = async (id) => {
  const response = await fetch(`${API_URL}/sportcomplexes/${id}/approve`, {
    method: 'POST',
    headers: getDefaultHeaders(),
  });

  if (response.ok) {
    return await response.json();
  } else {
    await handleError(response);
  }
};

const rejectSportComplex = async (id) => {
  const response = await fetch(`${API_URL}/sportcomplexes/${id}/reject`, {
    method: 'POST',
    headers: getDefaultHeaders(),
  });

  if (response.ok) {
    return await response.json();
  } else {
    await handleError(response);
  }
};

const handleError = async (response) => {
  if (response.status === 401) {
    setToken(null);
    window.localStorage.removeItem('access_token');
    let error = new Error('Unauthorized');
    try {
      const responseBody = await response.json();
      // OpenIdConnect возвращает error_description, обычные API возвращают detail
      if (responseBody.error_description) {
        error.message = responseBody.error_description;
      } else if (responseBody.detail) {
        error.message = responseBody.detail;
      } else if (typeof responseBody === 'string') {
        error.message = responseBody;
      }
    } catch (err) {
      // do nothing
    }
    error.httpStatus = 401;
    // Бросаем ошибку, чтобы клиент мог обработать её
    throw error;
  }
  
  // Пытаемся извлечь понятное сообщение об ошибке
  let errorMessage = `Ошибка ${response.status}`;
  if (response.status === 400) {
    errorMessage = 'Неверный запрос';
  } else if (response.status === 403) {
    errorMessage = 'Доступ запрещен';
  } else if (response.status === 404) {
    errorMessage = 'Не найдено';
  } else if (response.status === 500) {
    errorMessage = 'Ошибка сервера';
  } else if (response.status === 409) {
    errorMessage = 'Конфликт расписания';
  } else if (response.status === 422) {
    errorMessage = 'Ошибка валидации';
  }
  
  let error = new Error(errorMessage);
  try {
    // Пытаемся прочитать JSON
    const responseBody = await response.json();
    // Проверяем различные форматы ответов об ошибке
    if (responseBody.error_description) {
      error.message = responseBody.error_description;
    } else if (responseBody.detail) {
      error.message = responseBody.detail;
    } else if (responseBody.message) {
      error.message = responseBody.message;
    } else if (typeof responseBody === 'string') {
      error.message = responseBody;
    } else if (responseBody.title) {
      error.message = responseBody.title;
    }
  } catch (jsonErr) {
    // Если не удалось распарсить JSON, пробуем получить текст
    // Но только если body еще не был прочитан (response.bodyUsed === false)
    if (!response.bodyUsed) {
      try {
        const text = await response.text();
        if (text) {
          error.message = text;
        }
      } catch (textErr) {
        // do nothing - body уже прочитан или недоступен
      }
    }
  } finally {
    error.httpStatus = response.status;
    error.status = response.statusText;
    error.response = response;
    if (process.env.NODE_ENV === 'development') {
      console.log(error); // eslint-disable-line no-console
    }
  }
  throw error;
};

// Rental Items API
const getRentalItems = async (complexId) => {
  const url = complexId 
    ? `${API_URL}/rentalitems?complexId=${complexId}`
    : `${API_URL}/rentalitems`;
  const response = await fetch(url, {
    headers: getDefaultHeaders(),
  });
  let result;
  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }
  return result;
};

const getRentalItem = async (id) => {
  const response = await fetch(`${API_URL}/rentalitems/${id}`, {
    headers: getDefaultHeaders(),
  });
  let result;
  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }
  return result;
};

const getAvailableRentalItems = async (playgroundId, date) => {
  const params = new URLSearchParams();
  if (playgroundId) params.append('playgroundId', playgroundId);
  if (date) params.append('date', date);
  const response = await fetch(`${API_URL}/rentalitems/available?${params.toString()}`, {
    headers: getDefaultHeaders(),
  });
  let result;
  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }
  return result;
};

const getStandaloneRentalItems = async (complexId) => {
  const url = complexId 
    ? `${API_URL}/rentalitems/standalone?complexId=${complexId}`
    : `${API_URL}/rentalitems/standalone`;
  const response = await fetch(url, {
    headers: getDefaultHeaders(),
  });
  let result;
  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }
  return result;
};

const createStandaloneRentalBooking = async (bookingData) => {
  const response = await fetch(`${API_URL}/rentalitems/standalone-booking`, {
    method: 'POST',
    body: JSON.stringify(bookingData),
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  let result;
  if (response.ok) {
    result = await response.json();
  } else {
    // Для BadRequest пытаемся извлечь понятное сообщение
    // ASP.NET Core возвращает ошибки как plain text в BadRequest
    if (response.status === 400) {
      const errorText = await response.text();
      if (errorText) {
        const error = new Error(errorText);
        error.status = 'Bad Request';
        error.response = response;
        throw error;
      }
    }
    // Для других ошибок используем стандартную обработку
    await handleError(response);
  }
  return result;
};

const getStandaloneRentalBookings = async () => {
  const response = await fetch(`${API_URL}/rentalitems/standalone-bookings`, {
    headers: getDefaultHeaders(),
  });
  let result;
  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }
  return result;
};

const updateStandaloneRentalBooking = async (id, bookingData) => {
  const response = await fetch(`${API_URL}/rentalitems/standalone-bookings/${id}`, {
    method: 'PUT',
    body: JSON.stringify(bookingData),
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  let result;
  if (response.ok) {
    result = await response.json();
  } else {
    // Для BadRequest пытаемся извлечь понятное сообщение
    // ASP.NET Core возвращает ошибки как plain text в BadRequest
    if (response.status === 400) {
      const errorText = await response.text();
      if (errorText) {
        const error = new Error(errorText);
        error.status = 'Bad Request';
        error.response = response;
        throw error;
      }
    }
    // Для других ошибок используем стандартную обработку
    await handleError(response);
  }
  return result;
};

const deleteStandaloneRentalBooking = async (id) => {
  const response = await fetch(`${API_URL}/rentalitems/standalone-bookings/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });
  if (!response.ok) {
    await handleError(response);
  }
};

const checkRentalItemAvailability = async (rentalItemId, startDate, endDate, quantity = 1, excludeBookingId = null) => {
  const params = new URLSearchParams({
    rentalItemId: rentalItemId.toString(),
    startDate: startDate.toISOString(),
    quantity: quantity.toString(),
  });
  
  if (endDate) {
    params.append('endDate', endDate.toISOString());
  }
  
  if (excludeBookingId) {
    params.append('excludeBookingId', excludeBookingId.toString());
  }

  const response = await fetch(`${API_URL}/rentalitems/check-availability?${params.toString()}`, {
    headers: getDefaultHeaders(),
  });
  let result;
  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }
  return result;
};

const createRentalItem = async (model) => {
  const response = await fetch(`${API_URL}/rentalitems`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  let result;
  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }
  return result;
};

const updateRentalItem = async (id, model) => {
  const response = await fetch(`${API_URL}/rentalitems/${id}`, {
    method: 'PUT',
    body: JSON.stringify(model),
    headers: {
      ...getDefaultHeaders(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  let result;
  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }
  return result;
};

const deleteRentalItem = async (id) => {
  const response = await fetch(`${API_URL}/rentalitems/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });
  if (!response.ok) {
    await handleError(response);
  }
  return response.ok;
};

// Notification API
const getUserNotifications = async () => {
  const response = await fetch(`${API_URL}/notification`, {
    headers: getDefaultHeaders(),
  });
  let result;

  if (response.ok) {
    result = await response.json();
  } else {
    await handleError(response);
  }

  return result;
};

const markNotificationAsRead = async (id) => {
  const response = await fetch(`${API_URL}/notification/${id}/read`, {
    method: 'POST',
    headers: getDefaultHeaders(),
  });

  if (!response.ok) {
    await handleError(response);
  }

  return response.ok;
};

const markAllNotificationsAsRead = async () => {
  const response = await fetch(`${API_URL}/notification/mark-all-read`, {
    method: 'POST',
    headers: getDefaultHeaders(),
  });

  if (!response.ok) {
    await handleError(response);
  }

  return response.ok;
};

// Sections API
const buildQueryString = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : '';
};

const reportsScopeQuery = (scope, extra = {}) => {
  const s = scope && typeof scope === 'object' ? scope : { complexId: scope };
  const organizationId = s.organizationId || s.OrganizationId;
  if (organizationId) {
    return buildQueryString({ organizationId, ...extra });
  }
  return buildQueryString({ complexId: s.complexId || s.ComplexId, ...extra });
};

/**
 * Бэкенд может вернуть 204 No Content или пустое тело при PUT/PATCH — безопасный разбор.
 * @param {Response} response
 * @param {*} fallback значение, если тела нет (обычно отправленная модель)
 */
const parseOkResponseBody = async (response, fallback) => {
  if (response.status === 204) return fallback;
  const text = await response.text();
  if (!text || !text.trim()) return fallback;
  try {
    return JSON.parse(text);
  } catch {
    return fallback;
  }
};

const getSections = async ({ complexId, sport, search } = {}) => {
  const response = await fetch(`${API_URL}/sections${buildQueryString({ complexId, sport, search })}`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const getSection = async (id) => {
  const response = await fetch(`${API_URL}/sections/${id}`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const createSection = async (model) => {
  const response = await fetch(`${API_URL}/sections`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const updateSection = async (id, model) => {
  const sectionId = id || (model && model.id);
  const payload = { ...model, id: sectionId };
  const response = await fetch(`${API_URL}/sections/${sectionId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return parseOkResponseBody(response, payload);
  await handleError(response);
};

const deleteSection = async (id) => {
  const response = await fetch(`${API_URL}/sections/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });
  if (response.ok) return true;
  await handleError(response);
};

const getSectionGroups = async (sectionId) => {
  const response = await fetch(`${API_URL}/sections/${sectionId}/groups`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const createSectionGroup = async (sectionId, model) => {
  const response = await fetch(`${API_URL}/sections/${sectionId}/groups`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const updateSectionGroup = async (sectionId, groupId, model) => {
  const payload = { ...model, id: groupId, sectionId };
  const response = await fetch(`${API_URL}/sections/${sectionId}/groups/${groupId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return parseOkResponseBody(response, payload);
  await handleError(response);
};

const deleteSectionGroup = async (sectionId, groupId) => {
  const response = await fetch(`${API_URL}/sections/${sectionId}/groups/${groupId}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });
  if (response.ok) return true;
  await handleError(response);
};

const getSectionRequests = async ({ complexId, sectionId, status } = {}) => {
  const response = await fetch(`${API_URL}/sectionrequests${buildQueryString({ complexId, sectionId, status })}`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const updateSectionRequest = async (id, model) => {
  // BE SectionRequestPatchModel: Status (int?) или StatusName (string).
  // UI раньше слал status: 'InProgress' → binding int? падал → пустой 400 «Неверный запрос».
  const payload = { ...model };
  if (typeof payload.status === 'string' && !payload.statusName) {
    payload.statusName = payload.status;
    delete payload.status;
  }
  if (payload.id != null) delete payload.id;
  const response = await fetch(`${API_URL}/sectionrequests/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return parseOkResponseBody(response, payload);
  await handleError(response);
};

const getAbonements = async ({ complexId, sectionId, userId } = {}) => {
  const response = await fetch(`${API_URL}/abonements${buildQueryString({ complexId, sectionId, userId })}`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const createAbonement = async (model) => {
  const response = await fetch(`${API_URL}/abonements`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const updateAbonement = async (id, model) => {
  const abonementId = id || (model && model.id);
  const payload = { ...model, id: abonementId };
  const response = await fetch(`${API_URL}/abonements/${abonementId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return parseOkResponseBody(response, payload);
  await handleError(response);
};

const deleteAbonement = async (id) => {
  const response = await fetch(`${API_URL}/abonements/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });
  if (response.ok) return true;
  await handleError(response);
};


const getAbonementTariffs = async ({ complexId, sectionId, activeOnly } = {}) => {
  const response = await fetch(`${API_URL}/abonement-tariffs${buildQueryString({ complexId, sectionId, activeOnly })}`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const createAbonementTariff = async (model) => {
  const response = await fetch(`${API_URL}/abonement-tariffs`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const updateAbonementTariff = async (id, model) => {
  const tariffId = id || (model && model.id);
  const payload = { ...model, id: tariffId };
  const response = await fetch(`${API_URL}/abonement-tariffs/${tariffId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return parseOkResponseBody(response, payload);
  await handleError(response);
};

const deleteAbonementTariff = async (id) => {
  const response = await fetch(`${API_URL}/abonement-tariffs/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });
  if (response.ok) return true;
  await handleError(response);
};

const getAbonementsPaidSum = async ({ complexId, sectionId, from, to } = {}) => {
  const response = await fetch(`${API_URL}/abonement-tariffs/paid-sum${buildQueryString({ complexId, sectionId, from, to })}`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const getPersonalTrainings = async ({ complexId, sectionId, trainerId, userId, from, to } = {}) => {
  const response = await fetch(`${API_URL}/personaltrainings${buildQueryString({ complexId, sectionId, trainerId, userId, from, to })}`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const createPersonalTraining = async (model) => {
  const response = await fetch(`${API_URL}/personaltrainings`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const updatePersonalTraining = async (id, model) => {
  const trainingId = id || (model && model.id);
  const payload = { ...model, id: trainingId };
  const response = await fetch(`${API_URL}/personaltrainings/${trainingId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return parseOkResponseBody(response, payload);
  await handleError(response);
};

const deletePersonalTraining = async (id) => {
  const response = await fetch(`${API_URL}/personaltrainings/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });
  if (response.ok) return true;
  await handleError(response);
};

const getSectionOccurrences = async (sectionId, { from, to, groupId } = {}) => {
  const response = await fetch(`${API_URL}/sections/${sectionId}/occurrences${buildQueryString({ from, to, groupId })}`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const updateSectionOccurrence = async (sectionId, occurrenceId, model) => {
  const response = await fetch(`${API_URL}/sections/${sectionId}/occurrences/${occurrenceId}`, {
    method: 'PATCH',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return parseOkResponseBody(response, model);
  await handleError(response);
};

const createSectionOccurrence = async (sectionId, model) => {
  const response = await fetch(`${API_URL}/sections/${sectionId}/occurrences`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return parseOkResponseBody(response, model);
  await handleError(response);
};

const getSectionGroupMembers = async (sectionId, groupId) => {
  const response = await fetch(`${API_URL}/sections/${sectionId}/groups/${groupId}/members`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const getComplexSectionGroupMembers = async (complexId) => {
  const response = await fetch(
    `${API_URL}/sections/group-members${buildQueryString({ complexId })}`,
    { headers: getDefaultHeaders() },
  );
  if (response.ok) return await response.json();
  await handleError(response);
};

const getOrganizations = async () => {
  const response = await fetch(`${API_URL}/organizations`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const getOrganizationByComplex = async (complexId) => {
  const response = await fetch(`${API_URL}/organizations/by-complex/${complexId}`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const getOrganizationMembers = async (orgId) => {
  const response = await fetch(`${API_URL}/organizations/${orgId}/members`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const addOrganizationMember = async (orgId, model) => {
  const response = await fetch(`${API_URL}/organizations/${orgId}/members`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const assignOrganizationOwner = async (orgId, email) => {
  const response = await fetch(`${API_URL}/organizations/${orgId}/owner`, {
    method: 'POST',
    body: JSON.stringify({ email }),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const getOrganizationClientsPicker = async (orgId) => {
  const response = await fetch(`${API_URL}/organizations/${orgId}/clients-picker`, {
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const getOrganizationClients = async (orgId, q) => {
  const response = await fetch(
    `${API_URL}/organizations/${orgId}/clients${buildQueryString({ q })}`,
    { headers: getDefaultHeaders() },
  );
  if (response.ok) return await response.json();
  await handleError(response);
};

const createOrganizationClient = async (orgId, model) => {
  const response = await fetch(`${API_URL}/organizations/${orgId}/clients`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const unmergeOrganizationClient = async (orgId, clientId) => {
  const response = await fetch(`${API_URL}/organizations/${orgId}/clients/${clientId}/unmerge`, {
    method: 'POST',
    headers: getDefaultHeaders(),
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const addSectionGroupMember = async (sectionId, groupId, model) => {
  const response = await fetch(`${API_URL}/sections/${sectionId}/groups/${groupId}/members`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const removeSectionGroupMember = async (sectionId, groupId, memberId) => {
  const response = await fetch(`${API_URL}/sections/${sectionId}/groups/${groupId}/members/${memberId}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });
  if (response.ok || response.status === 204) return true;
  await handleError(response);
};

/** Единый оверлей секций + персональных на площадке (BE occupancy). */
const getPlaygroundSectionOccupancy = async (playgroundId, { from, to, sectionId, groupId } = {}) => {
  const response = await fetch(
    `${API_URL}/playgrounds/${playgroundId}/section-occupancy${buildQueryString({ from, to, sectionId, groupId })}`,
    { headers: getDefaultHeaders() },
  );
  if (response.ok) return await response.json();
  await handleError(response);
};

const createSectionOccurrenceBooking = async (model) => {
  const response = await fetch(`${API_URL}/section-occurrence-bookings`, {
    method: 'POST',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return await response.json();
  await handleError(response);
};

const getSectionOccurrenceBookings = async (sectionId, occurrenceId) => {
  const response = await fetch(
    `${API_URL}/sections/${sectionId}/occurrences/${occurrenceId}/bookings`,
    { headers: getDefaultHeaders() },
  );
  if (response.ok) return await response.json();
  await handleError(response);
};

const updateSectionOccurrenceAttendance = async (bookingId, model) => {
  const response = await fetch(`${API_URL}/section-occurrence-bookings/${bookingId}/attendance`, {
    method: 'PATCH',
    body: JSON.stringify(model),
    headers: { ...getDefaultHeaders(), Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  if (response.ok) return parseOkResponseBody(response, model);
  await handleError(response);
};

const cancelSectionOccurrenceBooking = async (id) => {
  const response = await fetch(`${API_URL}/section-occurrence-bookings/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(),
  });
  if (response.ok) return true;
  await handleError(response);
};

const extractNominatimCity = (address, displayName) => {
  if (address) {
    const city = address.city || address.town || address.village || address.municipality || address.county;
    if (city) return String(city).trim();
  }
  if (!displayName) return null;
  const parts = String(displayName).split(',').map(part => part.trim()).filter(Boolean);
  for (let i = 2; i < Math.min(parts.length, 6); i += 1) {
    if (parts[i].length > 2 && !/^\d+$/.test(parts[i])) return parts[i];
  }
  return null;
};

const extractNominatimStreet = (address, displayName) => {
  if (address && address.road) {
    return address.house_number
      ? `${address.road.trim()}, д. ${String(address.house_number).trim()}`
      : address.road.trim();
  }
  if (!displayName) return null;
  const parts = String(displayName).split(',').map(part => part.trim()).filter(Boolean);
  return parts.slice(0, 3).join(', ') || null;
};

const parseGeoResult = (data) => {
  if (!data) return { city: null, countryCode: null, address: null };
  const nominatimAddress = data.address && typeof data.address === 'object' ? data.address : null;
  const city = data.city || data.City || extractNominatimCity(nominatimAddress, data.display_name);
  const address = typeof data.address === 'string'
    ? data.address
    : (data.Address || extractNominatimStreet(nominatimAddress, data.display_name));
  const countryCode = resolveCountryCode({
    ...data,
    country_code: data.countryCode || data.CountryCode
      || (nominatimAddress && (nominatimAddress.country_code || nominatimAddress['ISO3166-1-alpha-2'])),
    country: data.country || data.Country || (nominatimAddress && nominatimAddress.country),
  });
  return {
    city: city || null,
    countryCode,
    address: address || null,
  };
};

const reverseFromNominatim = async (lat, lng) => {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lng)}&zoom=18&addressdetails=1&accept-language=ru`,
    { headers: { Accept: 'application/json' } },
  );
  if (!response.ok) return null;
  return parseGeoResult(await response.json());
};

const reverseGeocode = async (lat, lng) => {
  try {
    const response = await fetch(`${API_URL}/geo/reverse?lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      const parsed = parseGeoResult(await response.json());
      if (parsed.city || parsed.countryCode || parsed.address) return parsed;
    }
  } catch (err) {
    console.warn('reverse geocode API failed', err);
  }
  try {
    const fallback = await reverseFromNominatim(lat, lng);
    if (fallback && (fallback.city || fallback.countryCode || fallback.address)) return fallback;
  } catch (err) {
    console.warn('reverse geocode Nominatim failed', err);
  }
  return { city: null, countryCode: null, address: null };
};

const api = {
  getCenters,
  getPendingComplexesCount: async () => {
    const response = await fetch(`${API_URL}/sportcomplexes/pending-count`, {
      method: 'GET',
      headers: getDefaultHeaders(),
    });

    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  /** Превью для модерации: площадки комплекса (название, виды спорта) и встречи. Только для админа. */
  getModerationPreview: async (complexId) => {
    const response = await fetch(`${API_URL}/sportcomplexes/${complexId}/moderation-preview`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) return await response.json();
    await handleError(response);
  },
  createCenter,
  updateCenter,
  reverseGeocode,
  getYClientsIntegration,
  putYClientsIntegration,
  getYClientsStaff,
  getYClientsServices,
  putYClientsBindings,
  getPlaygrounds,
  getPlayground,
  updatePlayground,
  createPlayground,
  getTimetable,
  createTimetable,
  addTimetable,
  updateUser,
  createUser,
  uploadPhoto,
  getBookings,
  getBooking,
  createBooking,
  updateBooking,
  bulkCancelBookings: async (ids) => {
    const response = await fetch(`${API_URL}/bookings/bulk-cancel`, {
      method: 'POST',
      headers: {
        ...getDefaultHeaders(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ids }),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  createRecurringBookings: async (request) => {
    const response = await fetch(`${API_URL}/bookings/bulk-create-recurring`, {
      method: 'POST',
      headers: {
        ...getDefaultHeaders(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  deletePhoto,
  updatePhoto,
  setDeviceUser,
  getUsers,
  auth,
  // Reports API
  getBookingsStatistics: async (from, to, periodType = 'day', scope) => {
    const response = await fetch(`${API_URL}/reports/bookings/statistics${reportsScopeQuery(scope, { from, to, periodType })}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  getPopularTimes: async (from, to, scope) => {
    const response = await fetch(`${API_URL}/reports/bookings/popular-times${reportsScopeQuery(scope, { from, to })}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  getPlaygroundsStatistics: async (from, to, scope) => {
    const response = await fetch(`${API_URL}/reports/playgrounds/statistics${reportsScopeQuery(scope, { from, to })}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  getRevenueByPeriod: async (from, to, periodType = 'day', scope) => {
    const response = await fetch(`${API_URL}/reports/financial/revenue-by-period${reportsScopeQuery(scope, { from, to, periodType })}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  getRevenueByLocation: async (from, to, scope) => {
    const response = await fetch(`${API_URL}/reports/financial/revenue-by-location${reportsScopeQuery(scope, { from, to })}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  getRevenueByRentalItems: async (from, to, scope) => {
    const response = await fetch(`${API_URL}/reports/financial/revenue-by-rental-items${reportsScopeQuery(scope, { from, to })}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  getPeriodComparison: async (from1, to1, from2, to2, scope) => {
    const response = await fetch(`${API_URL}/reports/financial/period-comparison${reportsScopeQuery(scope, { from1, to1, from2, to2 })}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  getReportsSummary: async (scope, from, to) => {
    const response = await fetch(`${API_URL}/reports/summary${reportsScopeQuery(scope, { from, to })}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  getReportsReceivables: async (scope, from, to) => {
    const response = await fetch(`${API_URL}/reports/receivables${reportsScopeQuery(scope, { from, to })}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  getReportsTrainers: async (scope, from, to, attendedOnly = false) => {
    const response = await fetch(`${API_URL}/reports/trainers${reportsScopeQuery(scope, {
      from,
      to,
      attendedOnly: attendedOnly ? true : undefined,
    })}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  getReportsClients: async (scope, from, to) => {
    const response = await fetch(`${API_URL}/reports/clients${reportsScopeQuery(scope, { from, to })}`, {
      headers: getDefaultHeaders(),
    });
    if (response.ok) {
      return await response.json();
    } else {
      await handleError(response);
    }
  },
  // Chat moderation (этап 2.0)
  getChatReports: async (status = null) => {
    const url = status != null
      ? `${API_URL}/chat/reports?status=${status}`
      : `${API_URL}/chat/reports`;
    const response = await fetch(url, { headers: getDefaultHeaders() });
    if (response.ok) return await response.json();
    await handleError(response);
  },
  resolveChatReport: async (id, body) => {
    const response = await fetch(`${API_URL}/chat/reports/${id}`, {
      method: 'PATCH',
      headers: { ...getDefaultHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (response.ok) return;
    await handleError(response);
  },
  setUserBan: async (userId, body) => {
    const response = await fetch(`${API_URL}/chat/users/${userId}/ban`, {
      method: 'PATCH',
      headers: { ...getDefaultHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (response.ok) return;
    await handleError(response);
  },
  setToken,
  getUser,
  getComments,
  deleteComment,
  deleteBooking,
  paidCancel,
  changePassword,
  deleteCenter,
  deletePlayground,
  getTimezoneList,
  registerModerator,
  resendConfirmation,
  confirmModeratorEmail,
  getModeratorStatus,
  approveSportComplex,
  rejectSportComplex,
  getRentalItems,
  getRentalItem,
  getAvailableRentalItems,
  getStandaloneRentalItems,
  createRentalItem,
  updateRentalItem,
  deleteRentalItem,
  createStandaloneRentalBooking,
  getStandaloneRentalBookings,
  updateStandaloneRentalBooking,
  deleteStandaloneRentalBooking,
  checkRentalItemAvailability,
  getUserNotifications,
  markNotificationAsRead,
  markAllNotificationsAsRead,
  getSections,
  getSection,
  createSection,
  updateSection,
  deleteSection,
  getSectionGroups,
  createSectionGroup,
  updateSectionGroup,
  deleteSectionGroup,
  getSectionRequests,
  updateSectionRequest,
  getAbonements,
  createAbonement,
  updateAbonement,
  deleteAbonement,
  getAbonementTariffs,
  createAbonementTariff,
  updateAbonementTariff,
  deleteAbonementTariff,
  getAbonementsPaidSum,
  getPersonalTrainings,
  createPersonalTraining,
  updatePersonalTraining,
  deletePersonalTraining,
  getSectionOccurrences,
  updateSectionOccurrence,
  createSectionOccurrence,
  getSectionGroupMembers,
  getComplexSectionGroupMembers,
  getOrganizations,
  getOrganizationByComplex,
  getOrganizationMembers,
  addOrganizationMember,
  assignOrganizationOwner,
  getOrganizationClientsPicker,
  getOrganizationClients,
  createOrganizationClient,
  unmergeOrganizationClient,
  addSectionGroupMember,
  removeSectionGroupMember,
  getPlaygroundSectionOccupancy,
  createSectionOccurrenceBooking,
  getSectionOccurrenceBookings,
  updateSectionOccurrenceAttendance,
  cancelSectionOccurrenceBooking,
  getDefaultHeaders,
};
export default api;
